export default __webpack_public_path__ + "3b2ee55220c7c6cef58d92b37969dcb2.svg";